var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationHashtag = function SvgGeneralInformationHashtag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.878 9.826.353-2h-15l-.353 2zM18.77 16.174l.352-2h-15l-.353 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.407 20.5 2.989-17h2l-2.99 17zM12.532 20.5l2.997-17h2l-2.997 17z"
  }))));
};
export default SvgGeneralInformationHashtag;